export enum RolePermissionsEnum {
    MODULE_ACCESS = 'View',
}